import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { caseInsensitiveFilter } from 'Common/GridHelper';

import {
  getErrors,
  getLoading,
  getExports,
  getDeleteSuccessful,
} from '../state/exportlist/selectors';

import {
  getSavedExports,
  clearError,
  deleteSavedExport,
  setDeleteSuccessful,
} from '../state/exportlist/actions';

class ExportGridContainer extends Component {
  state = {
    filtered: [],
  };

  columns = [
    {
      Header: 'File Name',
      accessor: 'FileName',
      filterable: true,
      resizable: false,
    },
    {
      width: 50,
      Cell: (gridProps) => {
        return GridContextMenu({
          gridProps,
          options: this.menuOptions(gridProps.original),
        });
      },
    },
  ];

  onEditClick = (savedExport) => {
    this.props.history.push(`/newyorksirsexport/${savedExport.Id}`);
  };

  onDeleteClick = (savedExport) => {
    const { deleteSavedExport } = this.props;
    deleteSavedExport(savedExport.Id);
  };

  menuOptions = () => {
    var options = [
      {
        icon: 'pencil',
        text: 'View/Edit',
        handler: (x) => this.onEditClick(x),
      },
      {
        icon: 'cancel',
        text: 'Delete',
        handler: (x) => this.onDeleteClick(x),
      },
    ];
    return options;
  };

  componentDidMount() {
    const { getSavedExports } = this.props;

    getSavedExports();
  }

  componentDidUpdate(prevProps) {
    const {
      clearError,
      deleteSuccessful,
      setDeleteSuccessful,
      getSavedExports,
    } = this.props;

    errorToast(this.props, prevProps, 'error', clearError);

    if (deleteSuccessful) {
      setDeleteSuccessful(null);
      createToast(toastType.success, 'Success', 'Export Deleted.');
      getSavedExports();
    }
  }

  render() {
    const { loading, savedExports } = this.props;

    const data = savedExports || [];

    return (
      <ReactTable
        minRows={5}
        loading={loading}
        data={data}
        resizable={false}
        className={'-striped -highlight grid--fixed-row-height'}
        defaultFilterMethod={caseInsensitiveFilter}
        filtered={this.state.filtered}
        onFilteredChange={(filtered) => this.setState({ filtered })}
        columns={this.columns}
      />
    );
  }
}

const mapDispatchToProps = {
  getSavedExports,
  deleteSavedExport,
  clearError,
  setDeleteSuccessful,
};

const mapStateToProps = (state) => {
  return {
    savedExports: getExports(state),
    loading: getLoading(state),
    error: getErrors(state),
    deleteSuccessful: getDeleteSuccessful(state),
  };
};

export const ExportGrid = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExportGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/components/ExportGrid.js